import getString from '@/helpers/GetStrings';

export default {
  data() {
    return {
    };
  },
  methods: {
    getString,

    notifyError(error) {
      this.$q.notify({
        message: error,
        type: 'negative',
        timeout: 4000,
        position: 'top-right',
      });
    },

    handleError(error) {
      if (error && error.response && error.response.data) {
        const code = error.response.data.code;
        console.warn(code);
        const fields = error.response.data.fields;

        if (fields) {
          for (const property in fields) {
            if (Object.prototype.hasOwnProperty.call(fields, property)) {
              const fieldString = this.getFieldString(property);
              const errorString = this.getFieldErrorString(fields[property].code);
              if (errorString) {
                this.notifyError(`${fieldString} - ${errorString}`);
              }
            }
          }
        } else if (error.response.status === 400) {
          this.notifyFormError();
        }
      }
    },
    notifyFormError() {
      const message = this.$store.state.stringsStore.language === 'nl'
        ? 'Controleer alle velden en probeer het opnieuw'
        : 'Check for missing fields and try again';
      this.notifyError(message);
    },

    getFieldErrorString(code) {
      let stringCode;
      switch (code) {
        case 'URL_IN_USE':
          stringCode = 'error.conflict.url';
          break;
        case 'NAME_IN_USE':
          stringCode = 'error.conflict.name';
          break;
        case 'VALUE_NOT_VALID':
          stringCode = 'error.invalid.general';
          break;
        case 'BLOCKS_NOT_VALID':
          stringCode = 'error.invalid.blocks';
          break;
        case 'FILE_NOT_FOUND':
          stringCode = 'error.notfound.file';
          break;
        case 'STATUS_DATETIME':
          stringCode = 'error.invalid.statusDatetime';
          break;
        case 'NOT_UNIQUE':
        case 'DUPLICATE':
          stringCode = 'error.conflict.general';
          break;

        default:
          stringCode = 'error.invalid.general';
          break;
      }
      return this.getString(stringCode);
    },

    getFieldString(code) {
      let string;
      switch (code) {
        case 'name':
          string = this.getString('name');
          break;
        case 'module':
          string = this.getString('module.navigation.fields.module');
          break;
        case 'categories':
          string = this.getString('block.field.custom.categories');
          break;
        case 'tags':
          string = this.getString('module.name.tags');
          break;
        case 'image':
          string = this.getString('block.field.custom.image');
          break;
        case 'content':
          string = this.getString('block.field.custom.content');
          break;
        case 'url':
          string = this.getString('url');
          break;
        case 'datetime_online':
          string = `${this.getString('datetime.label')} online`;
          break;
        case 'meta_og_image':
          string = this.getString('editor.meta.og.image');
          break;
        case 'label':
          string = this.getString('label');
          break;
        case 'filename':
          string = this.getString('filename');
          break;
        case 'show_once':
          string = this.getString('module.popup.show_once');
          break;
        case 'location_from':
          string = this.getString('module.redirect.fields.location_from');
          break;
        case 'catch_all':
          string = this.getString('module.redirect.fields.catch_all');
          break;
        case 'source':
          string = this.getString('source');
          break;
        case 'email':
          string = this.getString('email');
          break;
        case 'code':
          string = this.getString('module.etim.feature.properties.code');
          break;
        case 'title':
          string = this.getString('title');
          break;
        case 'online':
          string = this.getString('editor.block.field.online');
          break;
        case 'start':
          string = this.getString('module.events.field.start');
          break;
        case 'end':
          string = this.getString('emodule.events.field.end');
          break;
        case 'targets':
          string = this.getString('targets');
          break;
        case 'implementation':
          string = this.getString('module.reference.detail.implementation');
          break;
        case 'delivery_date':
          string = this.getString('module.reference.detail.deliveryDate');
          break;
        case 'project_scope':
          string = this.getString('module.reference.detail.projectScope');
          break;
        case 'branches':
          string = this.getString('block.field.custom.branches.label');
          break;
        case 'cover':
          string = this.getString('editor.block.header.cover');
          break;
        case 'map':
          string = 'Map';
          break;
        case 'status':
          string = 'Status';
          break;
        case 'restrict':
          string = 'Restrict';
          break;
        case 'parent':
          string = 'Parent';
          break;
        case 'popup':
          string = 'Popup';
          break;
        case 'type':
          string = 'Type';
          break;
        case 'request_subject':
          string = 'Request subject value';
          break;
        case 'location':
          string = 'Location';
          break;

        default:
          string = '';
          break;
      }
      return string;
    },
  },
};
